import React from "react";
import { FileTextOutlined } from "@ant-design/icons";
import { SectionCard } from "../Components/SectionCard";
import { PatchNotesList } from "../Components/PatchNotesList";
import "./PatchNotes.css";

export const PatchNotes = () => {
  return (
    <div className="patch-notes-page">
      <div className="account-header">
        <h1>Patch Notes</h1>
        <p>Release history for the Hero Launcher and games.</p>
      </div>

      <SectionCard
        icon={<FileTextOutlined />}
        title="Release History"
        description=""
      >
        <PatchNotesList />
      </SectionCard>
    </div>
  );
};

export default PatchNotes;
